// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_c3-a";
export var fulfillmentFormRail = "_c3-9";
export var headerTitleRow = "_c3-c";
export var orderDetailsWrapper = "_c3-7";
export var orderLinkTrigger = "_c3-2";
export var paymentInformationGrid = "_c3-h";
export var paymentSummaryColumn = "_c3-i";
export var shipmentContainer = "_c3-b";
export var shipmentDetailsMainPane = "_c3-8";
export var shipmentNavigationCard = "_c3-5";
export var shipmentNavigationRail = "_c3-3";
export var shipmentNavigationRailHeader = "_c3-4";
export var shipmentSummaryFact = "_c3-e";
export var shipmentSummaryGrid = "_c3-d";
export var shipmentSummaryMetadataRow = "_c3-f";
export var shipmentSummaryTags = "_c3-g";
export var shipmentWorkspace = "_c3-0";
export var shipmentWorkspaceContent = "_c3-6";
export var shipmentWorkspaceHeader = "_c3-1";